import * as angular from 'angular';
import { roleTypeLabel } from '../../../../components/sp-role-type/sp-role-type.exports';
import { makeSelectables } from '../make-selectables';

export class Controller {

    /** @ngInject */
    constructor(
        $filter,
        $state,
        $translate,
        Alert,
        DestructiveOperationModal,
        Groups,
        RoleResource,
    ) {
        this.$filter = $filter;
        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.Groups = Groups;
        this.RoleResource = RoleResource;
    }

    $onInit() {
        this.email = this.administrator.email;
        this.roleType = this.administrator.roleType;
        this.applications = makeSelectables(this.administrator.applicationIds, []);
        this.appTypes = makeSelectables(this.administrator.applicationTypeIds, []);
        this.groups = makeSelectables(this.administrator.groupIds, []);

        this.roleTypes = [
            'SUPER_ADMIN',
            'DEVELOPER_ADMIN',
            'APPLICATION_ADMIN',
            'ORGANIZATION_ADMIN',
            'SHARING_CENTER_ADMIN',
            'READ_ONLY_ADMIN',
            
        ];

        this.applications$.get().then(applications => this.applications = makeSelectables(this.administrator.applicationIds, applications));
        this.appTypes$.get().then(types => this.appTypes = makeSelectables(this.administrator.applicationTypeIds, types));
        this.groups$.get().then(groups => this.groups = makeSelectables(this.administrator.groupIds, groups));
    }

    roleTypeChanged() {
        if (this.roleType !== 'APPLICATION_ADMIN') {
            this.applications = makeSelectables([], this.applications.all());
            this.appTypes = makeSelectables([], this.appTypes.all());
        }
        if (this.roleType !== 'ORGANIZATION_ADMIN') {
            this.groups = makeSelectables([], this.groups.all());
        }
    }

    roleTypeLabel(roleType) {
        return roleTypeLabel(roleType);
    }

    getOldConfig() {
        const {id, email, roleType, applicationIds, applicationTypeIds, groupIds} = this.administrator;
        return {id, email, roleType, applicationIds, applicationTypeIds, groupIds};
    }

    getNewConfig() {
        return {
            id: this.administrator.id,
            email: this.email,
            roleType: this.roleType,
            applicationIds: this.applications.getSelectedIds(),
            applicationTypeIds: this.appTypes.getSelectedIds(),
            groupIds: this.groups.getSelectedIds(),
        };
    }

    notModified() {
        return angular.equals(this.getOldConfig(), this.getNewConfig());
    }

    save() {
        const {id} = this.administrator;
        const index = this.administrators.findIndex(u => u.id === id);

        const oldConfig = this.getOldConfig();
        const newConfig = this.getNewConfig();

        const onSuccess = () => {
            this.Alert('success', 'company.administrators.edit.saved');
            this.$state.go('^', {}, {reload: '^'});
        };

        this.isSaving = true;
        if (oldConfig.email === newConfig.email && oldConfig.roleType === newConfig.roleType) {
            if (newConfig.roleType === 'APPLICATION_ADMIN') {
                this.RoleResource.editApplicationAdminRole(this.companyId, newConfig)
                    .then(onSuccess)
                    .finally(() => this.isSaving = false)
            } else if (newConfig.roleType === 'ORGANIZATION_ADMIN') {
                this.RoleResource.editOrganizationAdminRole(this.companyId, newConfig)
                    .then(onSuccess)
                    .finally(() => this.isSaving = false)
            }
        } else {
            this.DestructiveOperationModal({
                titleKey: 'company.administrators.edit.title',
                textKey: 'company.administrators.edit.are-you-sure',
                onSubmit: params => this.RoleResource
                    .removeRoleInCompany(this.companyId, id, params)
                    .then(() => this.administrators.splice(index, 1))
                    .then(() => this.RoleResource.addNewRole(this.companyId, newConfig))
                    .then(onSuccess)
            })
                .finally(() => this.isSaving = false)
        }
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving || this.notModified();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/edit/edit-administrator.controller.js